var map = {
	"./pt-br.js": "d5d2",
	"./pt-br/$vuetify.js": "e522",
	"./pt-br/actions.js": "acd0",
	"./pt-br/banners.js": "e420",
	"./pt-br/components.js": "0893",
	"./pt-br/drawer.js": "0b19",
	"./pt-br/errors.js": "6101",
	"./pt-br/footer.js": "41b0",
	"./pt-br/formats.js": "8e369",
	"./pt-br/forms.js": "e2a9",
	"./pt-br/globals.js": "f945",
	"./pt-br/index.js": "107a",
	"./pt-br/integrations.js": "cbac",
	"./pt-br/listItems.js": "8c59",
	"./pt-br/messages.js": "9cbf",
	"./pt-br/modals.js": "37a4",
	"./pt-br/models.js": "1e0f",
	"./pt-br/navbar.js": "d278",
	"./pt-br/navigation.js": "08cd",
	"./pt-br/tables.js": "2875",
	"./pt-br/views.js": "869b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4790";